import { createQuery } from "react-query-kit";
import { API_END_POINT } from "../../constants";
import { getDataWithToken, getEndPoint } from "../../Utils/network.client";
import axios, { AxiosError } from "axios";
import UnionsModel from "../../models/masters/unions-model";



const url = getEndPoint(API_END_POINT.MASTER) +"/api/Unions/GetAllUnions";// //{/api/Unions/GetAllUnions}`)  //// "https://localhost:7054/api/Unions/GetAllUnions";
export const useGetUnions = createQuery<
  UnionsModel[],
  null,
  AxiosError
>({
  queryKey: ["keyUnionslist"],
  fetcher: (params) =>
    getDataWithToken<any>(url).then((response) => response.data?.result || console.log(response)),
    // axios.get(url, null).then((response) => response?.data?.result || console.log(response)),
  refetchOnWindowFocus: false,
});